<template>
  <div>
    <div v-if="dataloaded == false" class="blackbox-loader"></div>

    <div v-if="dataloaded == true" >
      <v-card outlined> 
        <v-card-title>
          <v-text-field
            style="max-width: 300px;"
            v-model="search"
            :color="companyPrimaryColor"
            placeholder="Zoeken"
            outlined
            hide-details     
            :background-color="$vuetify.theme.themes[theme].menu"                                            
            prepend-inner-icon="search"
            autocomplete="disabled"
            clearable>
          </v-text-field>
          <v-spacer></v-spacer>
          <div class="header-edit-button">
            <v-btn class="mx-2" fab darken color="primary" @click="newCompDialog = true">
              <v-icon darken>add</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="companies"
          :search="search"
          item-key="name"
          :itemsPerPage.sync="companyPages"
          hide-default-footer
          :no-results-text="`Geen resultaten gevonden voor: ${search}`"
          >

          <template v-slot:item="{item, isExpanded, expand}">
            <tr>
              <td>
                <div class="question-list-item active" v-bind:class="{  true: item.active }">
                  <div class="circle"></div>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <span v-for="(branch, index) in branches.filter(branch => branch.compId == item.id)" :key="index">
                  <span v-if="index == 0">{{ branches.filter(branch => branch.compId == item.id).length}} </span>
                </span>
              </td>
              <td>
                <span v-for="(api, key, index) in item.apiItems" :key="index">
                  <span v-if="api == true"> {{ key | capitalize }}</span>
                </span>
              </td>
              <td>{{ item.ratingView | capitalize }}</td>
              <td>
                <span v-for="(type, index) in companyTypes" :key="index">
                  <span v-if="type.id == item.type">{{ type.name}} </span>
                </span>
              </td>
              <td>
                <ul class="company-package-list" >
                <span v-for="(companyPackage, index) in item.packages" :key="index">
                  <span v-for="availablePackage in packages" :key="availablePackage.id">
                    <li class="company-package" v-if="companyPackage == availablePackage.id">-{{ availablePackage.name}} </li>
                  </span>
                </span>
              </ul>
              </td>
              <td>
                <v-btn style="float: right;" icon class="mx-0" @click="editCompany(item)">
                  <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="padding: 0;">
              <v-card  flat style="border-bottom: 1px solid rgba(0,0,0,0.12);" :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}">
                <v-card-text>
                  <b>Vestigingen</b>
                  <ul class="ma-0 pa-0">
                    <li v-for="(branch, index) in branches.filter(branch => branch.compId == item.id)" :key="branch.id" style="display: list-item;">
                      <span v-if="index != branches.filter(branch => branch.compId == item.id).length - 1">&#9632; {{ branch.branchName }}</span>
                      <span v-if="index == branches.filter(branch => branch.compId == item.id).length - 1">&#9632; {{ branch.branchName }}</span>
                    </li>
                  </ul>
                </v-card-text>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- / New Company Dialog \ -->
    <v-dialog v-model="newCompDialog" scrollable max-width="600px">
      <add-comp-form @newCompDialogChange="newCompDialog = $event" @updateData="updateData()"></add-comp-form>
    </v-dialog>
    <!-- \ New Company Dialog / -->

    <!-- / Edit Company Dialog \ -->
    <edit-comp-form  :editCompDialog="editCompDialog" :selectedCompany="selectedCompanyInfo" :selectedCompanyOriginal="selectedCompanyInfoOriginal" @editCompDialogChange="editCompDialog = $event" @updateData="updateData()"></edit-comp-form>
    <!-- \ Edit Company Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import _lodash from "lodash";
import AddCompForm from "../components/modals/AddCompForm.vue";
import EditCompForm from "../components/modals/EditCompForm.vue";

export default {
  components: {
    "add-comp-form": AddCompForm,
    "edit-comp-form": EditCompForm
  },
  name: "companies",
  data: () => ({
    search: "",
    companyPages: -1,
    dataloaded: false,
    editCompDialog: false,
    newCompDialog: false,
    selectedCompanyInfo: {
      colors: {
        primary: "#5f1d9a",
        secondary: "#e5007d"
      }
    },
    selectedCompanyInfoOriginal: {},
    removeBookings: "",
    selected: [],
    branches: [],
    companies: [],
    companyTypes: [
      {
        name: "Kapper",
        id: "hairsalon"
      },
      {
        name: "Anders",
        id: "other"
      }
    ],
    packages: [
      {
        name: "Customer Journey",
        id: "customerjourney"
      },
      {
        name: "Barometers",
        id: "barometers"
      },
      {
        name: "Dossier",
        id: "dossier"
      },
      {
        name: "Narrowcasting",
        id: "narrowcasting"
      }
    ],
    languages: [
      {
        code: "nl",
        name: "Nederlands"
      },
      {
        code: "en",
        name: "Engels"
      }
    ],
    headers: [
      {
        text: "",
        align: "right",
        value: "",
        sortable: false,
        width: "30px"
      },
      {
        text: "Bedrijfsnaam",
        align: "left",
        value: "name"
      },
      {
        text: "Vestigingen",
        align: "left",
        value: "branches"
      },
      {
        text: "API",
        align: "left",
        value: "apiItems"
      },
      {
        text: "Beoordelingsweergave",
        align: "left",
        value: "branches"
      },
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      {
        text: "Paketten",
        align: "left",
        value: "packages",
        sortable: false,
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      }
    ]
  }),

  created() {
    this.loadCompanies();
  },

  methods: {
    updateData() {
      this.loadCompanies();
    },

    editCompany(item) {
      this.editedIndex = this.companies.indexOf(item);
      this.selectedCompanyInfo = Object.assign({}, item);
      this.selectedCompanyInfoOriginal = _.cloneDeep(this.selectedCompanyInfo);
      this.editCompDialog = true;
    },

    loadCompanies() {
      this.dataloaded = false
      db.collection("companies")
        .get()
        .then(snap => {
          this.companies = [];
          snap.forEach(doc => {
            let compCollection = doc.data();
            compCollection.id = doc.id;
            this.companies.push(compCollection);
          });
        })
        .then(()=>{
          this.loadBranches()
        })
    },
    loadBranches() {
      db.collection("branches")
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            this.branches.push(branchCollection);
          });
        })
        .then(()=>{
          this.dataloaded = true
        })
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
